import Expander from 'components/utils/Expander'
import NavBarContactsItems from 'components/NavKit/NavBarButtons/NavBarContactsItems'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'
import GeoContext from 'contexts/geoContext'
import useToggle from 'hooks/useToggle'
import shouldRenderTimely from 'lib/timely/timely'
import LineAngleDownBIcon from 'LuxKit/Icons/line/LineAngleDownBIcon'
import LineAngleUpBIcon from 'LuxKit/Icons/line/LineAngleUpBIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import { rem } from 'polished'
import { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const SummaryListItem = styled(ClickableListItem)`
  padding: ${rem(8)};
`

interface Props {
  onItemClick: () => void
}

function NavBarHamburgerMenuContactsAccordion(props: Props) {
  const { onItemClick } = props
  const intl = useIntl()
  const [expanded, toggleExpanded] = useToggle()
  const { currentRegionCode } = useContext(GeoContext)

  const contactOrVisitTitle = intl.formatMessage({
    id: 'b22MFRDZjlNBiR6HNsYh',
    defaultMessage: 'Contact or visit us',
  })
  const contactUsOnlyTitle = intl.formatMessage({
    id: '40bVsRMvxubQsEdLc7Cw',
    defaultMessage: 'Contact us',
  })
  const summaryTitle = shouldRenderTimely(currentRegionCode) ? contactOrVisitTitle : contactUsOnlyTitle

  const summarySubtitle = intl.formatMessage({
    id: 'VJsd-xJLC1JE0iwO2pfO',
    defaultMessage: 'Luxury Escapes support',
  })

  return (
    <div>
      <SummaryListItem
        size="medium"
        onClick={toggleExpanded}
        title={summaryTitle}
        subtitle={summarySubtitle}
        startIcon={<NavBarListItemIcon Icon={LinePhoneIcon} />}
        endIcon={expanded
          ? <LineAngleUpBIcon />
          : <LineAngleDownBIcon />}
      />
      <Expander expanded={expanded}>
        <NavBarContactsItems onItemClick={onItemClick} />
      </Expander>
    </div>
  )
}

export default NavBarHamburgerMenuContactsAccordion
